import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-not-submitted-view-dialog',
  templateUrl: './not-submitted-view-dialog.component.html',
  styleUrls: ['./not-submitted-view-dialog.component.scss'],
})
export class NotSubmittedViewDialogComponent {
  readonly gifSrc = 'assets/image/not-submitted.gif';
  readonly fallbackSrc = 'assets/image/nodata.png';
  imageSrc = this.gifSrc;

  constructor(
    private readonly ref: MatDialogRef<NotSubmittedViewDialogComponent>,
  ) {}

  onImageError(): void {
    if (this.imageSrc !== this.fallbackSrc) {
      this.imageSrc = this.fallbackSrc;
    }
  }

  close(): void {
    this.ref.close();
  }
}
